const appConfig = {
    locale: {
        main: "zh",
        available: ["zh","en","fr"]
    },
}
export default appConfig


